import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyDocumentTitle } from "../Hooks/useDocumentTitle";
import { findRouteTitle } from "../routeTitles";

// Sets a default document title on every route change so the tab always
// reflects the current page (WCAG 2.4.2). Rendered as the FIRST child of
// AppRoutes so its effect runs before any route component's — pages that set
// their own title (public i18n pages, detail pages with record-specific
// titles) overwrite this default in the same or a later commit.
export default function DocumentTitleManager({ isAuthenticated }) {
  const { pathname } = useLocation();

  useEffect(() => {
    // No entry → bare site name, so stale titles never linger on unmapped
    // routes; self-titling pages overwrite it right after.
    applyDocumentTitle(findRouteTitle(pathname, isAuthenticated));
  }, [pathname, isAuthenticated]);

  return null;
}
